import React from 'react'
import { PageHeader, PageTitle } from '../pageLayoutStyles'

export const HubCompanyMeetingRoomReservePage = (): JSX.Element => {
  return (
    <PageHeader>
      <PageTitle>Reservar espaço</PageTitle>
    </PageHeader>
  )
}
